module.exports = __webpack_public_path__ + "static/media/go.adc19434.svg";